import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  const logout = () => {
    sessionStorage.removeItem('authToken');
    navigate('/');
  };

  return (
    <div className="ml-64 min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <button
        onClick={logout}
        className="absolute top-5 right-5 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded shadow"
      >
        Logout
      </button>
      <h1 className="text-4xl font-bold text-gray-800">Welcome to the Dashboard</h1>
    </div>
  );
};

export default Dashboard;

